<template>
  <main-sidebar :name="name" :title="`${data.client_name} / ${data.facility}`">
    <div class="p-4">
      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <input-date
            v-model="insuranceExpirationDate"
            :value="insuranceExpirationDate"
            :label="$t('insurance_expiration_date')"
            name="insuranceExpirationDate"
            :disabled="!allowEditing"
          />
        </div>
      </div>
      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <label>{{ $t('insurance_company') }}</label>
          <v-select
            :options="vendorOptions"
            label="name"
            :reduce="(vendor) => vendor.id"
            v-model="insuranceCompany"
            v-validate="'required'"
            name="insuranceCompany"
            class="w-full"
            :disabled="!allowEditing"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('insuranceCompany')"
            >{{ errors.first('insuranceCompany') }}</span
          >
        </div>
      </div>
      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <label>{{ $t('insured_amount') }}</label>
          <vs-input
            class="w-full"
            type="number"
            v-model="insuredAmount"
            name="insuredAmount"
            v-validate="'required'"
            :disabled="!allowEditing"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('insuredAmount')"
            >{{ errors.first('insuredAmount') }}</span
          >
        </div>
      </div>
      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <label>{{ $t('insurance_file') }}</label>
          <UploadFile
            v-model="insuranceFile"
            list
            btnColor="primary"
            class="w-full"
            btnClass="w-full"
            accept="application/pdf"
            :disabled="!allowEditing"
          />
        </div>
      </div>
    </div>

    <div class="mx-4" slot="footer">
      <vs-button
        color="primary"
        type="filled"
        class="mr-6"
        :disabled="!allowEditing"
        @click="submit"
      >
        {{ $t('submit') }}
      </vs-button>
      <vs-button color="primary" type="border" @click="close">
        {{ $t('cancel') }}
      </vs-button>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import InputDate from '@/components/custom/InputDate'
import vSelect from 'vue-select'
import loading from '@/mixins/Loading'
import validate from '@/mixins/Validate.js'
import UploadFile from '@/views/components/UploadFile'
export default {
  components: {
    MainSidebar,
    vSelect,
    InputDate,
    UploadFile,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return this.loading.submit
    },
    vendorOptions() {
      let list = this.vendors.filter((v) => v.category_contract_id === '14')
      return list.length > 0
        ? list
        : [
            {
              id: '00',
              name: this.$i18n.messages[this.$i18n.locale].no_results,
            },
          ]
    },
  },
  data: () => ({
    name: 'edit-insurance',
    allowEditing: false,
    insuranceCompany: 0,
    insuredAmount: 0,
    insuranceExpirationDate: '',
    insuranceFile: [],
    loading: {
      submit: false,
    },
  }),
  methods: {
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    init() {
      this.allowEditing = this.hasPermission(['IU COMPLIANCE EDIT'])
      
      if (this.data.insurance_file != null) {
        this.insuranceCompany = this.data.insurance_company
        this.insuredAmount = this.data.insured_amount
        this.insuranceExpirationDate = this.data.insurance_expiration_date
      }
      
    },
    submit() {
      this.loading.submit = true
      let form = new FormData()
      form.append('lease_id', this.data.lease_id)
      form.append('insurance_company', this.insuranceCompany)
      form.append('insured_amount', this.insuredAmount)
      form.append('insurance_expiration_date', this.insuranceExpirationDate)
      if(this.insuranceFile.length > 0){
        form.append('insurance_file', this.insuranceFile[0])
      }
      this.$store
        .dispatch('compliance/updateComplianceLeaseInsurance', form)
        .then((res) => {
          this.$store.dispatch('getNotifications')
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Item Updated',
          })
          this.loading.submit = false
          this.close()
        })
        .catch((res) => {
          this.loading.submit = false
          this.displayErrors(res)
        })
    },
  },
  mixins: [loading, validate],
  props: {
    vendors: {
      type: Array,
      required: true,
    },
    data: {
      type: Object,
      default: () => ({
        insurance_company: 0,
        insured_amount: 0,
        insurance_expiration_date: '',
        client_name: '',
        facility: '',
      }),
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    },
  },
}
</script>

<style>
</style>